function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var GameZoomTemplate = require('./game-zoom.template');
var GameZoom = /*#__PURE__*/function () {
  function GameZoom(app, mod, minimap) {
    _classCallCheck(this, GameZoom);
    this.app = app;
    this.mod = mod;
    this.minimap = minimap;
    this.min = 2;
    this.max = 200;
    this.step = 5;
    this.el = null;
    this.fill_el = null;
    this.track_el = null;
    this.hide_delay = 1400;
    this.interaction_hide_delay = 3200;
    this.fade_ms = 450;
    this.hide_timer = null;
    this.fade_timer = null;
    this.interacted = false;
    this.dragging = false;
    this.attached = false;
    this.initialized = false;
  }
  return _createClass(GameZoom, [{
    key: "render",
    value: function render(parent_el) {
      if (!parent_el) {
        return;
      }
      if (!this.el) {
        this.app.browser.addStylesheet('/saito/css-imports/ui/game-zoom.css');
        this.app.browser.addElementToElement(GameZoomTemplate(), parent_el);
        this.el = parent_el.querySelector('.game-zoom');
        if (this.el) {
          this.track_el = this.el.querySelector('.track');
          this.fill_el = this.el.querySelector('.fill');
          this.attachEvents();
        }
      }
      if (!this.initialized) {
        this.initialized = true;
        var board = this.mod.getBoardElement();
        if (board) {
          var saved_scale = this.mod.loadGamePreference(this.mod.returnSlug() + '-board-scale');
          var view_ready = this.mod.default_board_view ? this.mod.loadGamePreference(this.mod.returnSlug() + '-board-view-set') : 1;
          if (this.mod.remember_board_position === false) {
            if (this.mod.default_board_scale) {
              this.mod.setBoardScale(this.mod.default_board_scale, false);
            } else {
              this.mod.centerBoard();
            }
          } else if (saved_scale && view_ready) {
            this.mod.setBoardScale(saved_scale, false);
            var boardoffset = null;
            try {
              boardoffset = this.mod.loadGamePreference(this.mod.returnSlug() + '-board-offset');
            } catch (err) {}
            var s = (Number(saved_scale) || 100) / 100;
            var inWindow = boardoffset && this.mod.boardOffsetInWindow(boardoffset.left, boardoffset.top, board.offsetWidth * s, board.offsetHeight * s);
            if (inWindow) {
              board.style.left = boardoffset.left + 'px';
              board.style.top = boardoffset.top + 'px';
            } else if (boardoffset) {
              this.mod.deleteGamePreference(this.mod.returnSlug() + '-board-offset');
            }
          } else if (this.mod.default_board_view) {
            this.applyDefaultBoardView(board);
            this.mod.saveGamePreference(this.mod.returnSlug() + '-board-view-set', 1);
          } else if (this.mod.default_board_scale) {
            this.mod.setBoardScale(this.mod.default_board_scale);
          } else {
            this.mod.centerBoard();
          }
          if (this.mod.ensureBoardVisible) {
            this.mod.ensureBoardVisible();
          }
        }
      }
      var b = this.mod.getBoardState();
      if (!b || !this.fill_el) {
        return;
      }
      var scale = Math.round(b.scale * 100);
      var t = (this.max - scale) / (this.max - this.min);
      t = Math.max(0, Math.min(1, t));
      this.fill_el.style.width = t * 100 + '%';
    }
  }, {
    key: "applyDefaultBoardView",
    value: function applyDefaultBoardView(board) {
      var view = this.mod.default_board_view;
      var boardWidth = board.offsetWidth;
      var boardHeight = board.offsetHeight;
      if (!view || !boardWidth || !boardHeight || !view.w || !view.h) {
        return;
      }
      var scale = Math.round(100 * window.innerWidth / (view.w * boardWidth));
      scale = Math.max(this.min, Math.min(this.max, scale));
      this.mod.setBoardScale(scale, false);
      var s = scale / 100;
      this.mod.setBoardPosition(Math.round(-view.x * boardWidth * s), Math.round(-view.y * boardHeight * s));
      this.mod.saveGamePreference(this.mod.returnSlug() + '-board-scale', scale);
    }
  }, {
    key: "show",
    value: function show() {
      if (!this.el || !this.minimap.minimap_el) {
        return;
      }
      clearTimeout(this.hide_timer);
      clearTimeout(this.fade_timer);
      this.hide_timer = null;
      this.fade_timer = null;
      this.minimap.minimap_el.classList.add('has-zoom');
      this.minimap.minimap_el.classList.remove('zoom-fading');
    }
  }, {
    key: "hide",
    value: function hide() {
      var _this = this;
      if (this.dragging || !this.minimap.minimap_el) {
        return;
      }
      if (this.hide_timer || this.fade_timer) {
        return;
      }
      var delay = this.interacted ? this.interaction_hide_delay : this.hide_delay;
      this.hide_timer = setTimeout(function () {
        _this.hide_timer = null;
        if (_this.dragging) {
          return;
        }
        if (_this.minimap.minimap_el && _this.minimap.minimap_el.matches(':hover')) {
          return;
        }
        _this.minimap.minimap_el.classList.add('zoom-fading');
        _this.fade_timer = setTimeout(function () {
          _this.fade_timer = null;
          _this.interacted = false;
          if (_this.minimap.minimap_el) {
            _this.minimap.minimap_el.classList.remove('has-zoom', 'zoom-fading');
          }
        }, _this.fade_ms);
      }, delay);
    }
  }, {
    key: "setZoom",
    value: function setZoom(scale) {
      scale = Math.max(this.min, Math.min(this.max, Math.round(Number(scale) || this.min)));
      this.mod.setBoardScale(scale);
      this.minimap.render();
    }
  }, {
    key: "attachEvents",
    value: function attachEvents() {
      if (this.attached || !this.el) {
        return;
      }
      this.attached = true;
      var zoom_self = this;
      this.el.addEventListener('mousedown', function (e) {
        e.stopPropagation();
      });
      this.el.addEventListener('click', function (e) {
        e.stopPropagation();
        zoom_self.interacted = true;
        zoom_self.show();
      });
      this.el.addEventListener('touchstart', function (e) {
        e.stopPropagation();
      }, {
        passive: true
      });
      this.el.querySelector('.center').addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        zoom_self.mod.centerBoard();
        zoom_self.minimap.render();
        zoom_self.interacted = true;
        zoom_self.show();
      });
      this.el.querySelector('.plus').addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var b = zoom_self.mod.getBoardState();
        zoom_self.setZoom((b ? Math.round(b.scale * 100) : 100) + zoom_self.step);
        zoom_self.interacted = true;
        zoom_self.show();
      });
      this.el.querySelector('.minus').addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var b = zoom_self.mod.getBoardState();
        zoom_self.setZoom((b ? Math.round(b.scale * 100) : 100) - zoom_self.step);
        zoom_self.interacted = true;
        zoom_self.show();
      });
      this.track_el.addEventListener('pointerdown', function (e) {
        e.preventDefault();
        e.stopPropagation();
        zoom_self.dragging = true;
        zoom_self.track_el.setPointerCapture(e.pointerId);
        var box = zoom_self.track_el.getBoundingClientRect();
        if (box.width) {
          var t = Math.max(0, Math.min(1, (e.clientX - box.left) / box.width));
          zoom_self.setZoom(zoom_self.max - t * (zoom_self.max - zoom_self.min));
        }
        zoom_self.interacted = true;
        zoom_self.show();
      });
      this.track_el.addEventListener('pointermove', function (e) {
        if (!zoom_self.dragging) {
          return;
        }
        var box = zoom_self.track_el.getBoundingClientRect();
        if (!box.width) {
          return;
        }
        var t = Math.max(0, Math.min(1, (e.clientX - box.left) / box.width));
        zoom_self.setZoom(zoom_self.max - t * (zoom_self.max - zoom_self.min));
      });
      this.track_el.addEventListener('pointerup', function () {
        zoom_self.dragging = false;
        zoom_self.interacted = true;
        zoom_self.show();
      });
      this.track_el.addEventListener('pointercancel', function () {
        zoom_self.dragging = false;
      });
      var board = this.mod.getBoardElement();
      if (board) {
        board.addEventListener('wheel', function (event) {
          if (event.deltaY === 0) {
            return;
          }
          event.preventDefault();
          var b = zoom_self.mod.getBoardState();
          var scale = b ? Math.round(b.scale * 100) : 100;
          zoom_self.setZoom(scale + (event.deltaY < 0 ? 1 : -1) * zoom_self.step);
        }, {
          passive: false
        });
        if (typeof $ !== 'undefined') {
          $(board).draggable({
            stop: function stop() {
              zoom_self.mod.saveBoardDocumentOffset(board);
              zoom_self.minimap.render();
            }
          });
        }
      }
    }
  }]);
}();
module.exports = GameZoom;